import { Box, Stack, Container, IconButton } from "@mui/material";
import { FiShare, FiGithub } from "react-icons/fi";
import ListButton from "./ListButton";
import ListIcon from "./ListIcon";
import BrandDetails from "./BrandDetails";
import BgVideo from "./BackgroundVideo";
import VisitStore from "./VisitStore";
import { itemsList } from "../itemsList";
import { useState } from "react";
import ShareModal from "./ShareModal";

export default function BioLink() {
    const [open, setOpen] = useState(false);
    const shareLink = "https://pin.bilalabdulhadi.com";

    return (
        <Box sx={{ minHeight: "100vh", width: "100vw", position: "relative" }}>
            <BgVideo />

            {/* ICON BAR */}
            {/* ICON BAR */}
            <Container
                maxWidth="sm"
                sx={{
                    display: "flex",
                    gap: 2,
                    pt: 5,

                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    flexWrap: "nowrap",

                    justifyContent: { xs: "center", sm: "center" },

                    /* Hide scrollbar */
                    scrollbarWidth: "none", // Firefox
                    "&::-webkit-scrollbar": {
                        display: "none", // Chrome/Safari
                    },

                    /* Smooth scrolling on mobile */
                    WebkitOverflowScrolling: "touch",
                }}>
                {itemsList
                    .filter((item) => item.showInIcons)
                    .map((item) => (
                        <Box key={item.id} sx={{ flex: "0 0 auto" }}>
                            <ListIcon href={item.href} icon={item.icon} />
                        </Box>
                    ))}
            </Container>

            {/* MAIN CONTENT */}
            <Container
                maxWidth="sm"
                sx={{
                    minHeight: "85vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 4,
                    marginBottom: 4,
                }}>
                <Box
                    sx={{
                        width: "100%",
                        textAlign: "center",
                        background: "rgba(255,255,255,0.3)",
                        backdropFilter: "blur(16px)",
                        borderRadius: 4,
                        p: 4,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                        position: "relative",
                    }}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: 16,
                            right: 16,
                            display: "flex",
                            gap: 0.5,
                        }}>
                        <IconButton
                            component="a"
                            href="https://github.com/bilalabdulhadii/react-pin-linktree"
                            target="_blank"
                            rel="noopener noreferrer">
                            <FiGithub />
                        </IconButton>

                        <IconButton onClick={() => setOpen(true)}>
                            <FiShare />
                        </IconButton>
                    </Box>

                    <BrandDetails />

                    <Stack spacing={1.5}>
                        <VisitStore />

                        {itemsList
                            .filter((item) => item.showInButtons)
                            .map((item) => (
                                <ListButton
                                    key={item.id}
                                    href={item.href}
                                    text={item.text}
                                />
                            ))}
                    </Stack>
                </Box>
            </Container>

            <ShareModal open={open} setOpen={setOpen} shareLink={shareLink} />
        </Box>
    );
}
